import { AutenticacionService } from './autenticacion.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';

@Injectable()
export class InversionistasService {

  private service_url: string;
  private api_url: string;
  private module_url: string;

  constructor( private http: Http,
               private constantsServices: ConstantsService,
               private validatorService: ValidatorService,
               private errorService: ErrorsService,
               private authService: AutenticacionService) {
      this.api_url = constantsServices.apiURL;
      this.module_url = '/inversionistas';
      this.service_url = this.api_url + this.module_url;
  }

  public getDefaultSchedule() {
    return {
      'idInversionistas': '',
      'nombre': '',
      'fecha': '',
      'estadoCivil': '',
      'rfc': '',
      'curp': '',
      'telefono': '',
      'email': '',
      'domicilio': '',
      'cp': '',
      'colonia': '',
      'nombreBanco': '',
      'numeroCuenta': '',
      'clabeBanco': ''
    };
  }

  public createInversionista(data) {

      return this.http.post(this.service_url, data, this.authService.getAuthHeaders());
  }

  public updateInversionista(data, id) {
    return this.http.put(this.service_url + '?id=' + id, data, this.authService.getAuthHeaders());
  }

  public searchInversionistas(text, page = null) {
    if (page) {
      return this.http.get(this.service_url + '?paginate=true&search=' + text + '&page=' + page, this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true&search=' + text, this.authService.getAuthHeaders());
  }


  public getInversionistas(page = null) {

    if (page) {
      return this.http.get(this.service_url + '?paginate=true&page=' + page, this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true', this.authService.getAuthHeaders());
  }

  public getInversionistasList(preffix = null) {
    if (preffix) {
      return this.http.get(this.api_url + preffix + this.module_url + '/lista', this.authService.getAuthHeaders());  
    } 
    return this.http.get(this.service_url + '/lista', this.authService.getAuthHeaders());
  }

  public writePermission() {
    return this.authService.hasPermission(6, true);
  }

  public canExport() {
    return this.authService.canExport();
  }

  public export(search) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    return this.http.get(this.service_url + '/exportar?search='+search, options)
    .map((response) => {
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.blob());
      const contentDispositionHeader = response.headers.get('content-disposition');
      const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
      link.download = result.replace(/"/g, '');
      document.body.appendChild(link); 
      link.click();
      setTimeout(() => {
        link.remove();
      }, 200);
    });
  }

  public validateInversionista(data) {
    console.log('validating... ', data);
    let error = [];

    // validacion de TÍTULO
    if (!this.validatorService.required(data['titulo'])) {
      error['titulo'] = this.errorService.required;
    } else if (!this.validatorService.max(data['titulo'], 40)) {
      error['titulo'] = this.errorService.max(40);
    }

    // validacion de NOMBRE
    if (!this.validatorService.required(data['nombre'])) {
      error['nombre'] = this.errorService.required;
    } else if (!this.validatorService.max(data['nombre'], 50)) {
      error['nombre'] = this.errorService.max(50);
    }

    // validacion de FECHA NACIMIENTO
    if (!this.validatorService.required(data['fecha'])) {
      error['fecha'] = this.errorService.required;
    } else if (!this.validatorService.date(data['fecha'])) {
      error['fecha'] = this.errorService.generic;
    }

    // validacion de ESTADO CIVIL
    if (!this.validatorService.required(data['estadoCivil'])) {
      error['estadoCivil'] = this.errorService.required;
    } else if (!this.validatorService.max(data['estadoCivil'], 40)) {
      error['estadoCivil'] = this.errorService.max(40);
    }

    // validacion de RFC
    if (!this.validatorService.required(data['rfc'])) {
      error['rfc'] = this.errorService.required;
    } else if (!this.validatorService.max(data['rfc'], 15)) {
      error['rfc'] = this.errorService.max(15);
    }

    // validacion de CURP
    if (!this.validatorService.required(data['curp'])) {
      error['curp'] = this.errorService.required;
    } else if (!this.validatorService.max(data['curp'], 18)) {
      error['curp'] = this.errorService.max(18);
    }

    // validacion de EMAIL
    if (!this.validatorService.required(data['email'])) {
      error['email'] = this.errorService.required;
    } else if (!this.validatorService.max(data['email'], 40)) {
      error['email'] = this.errorService.max(40);
    } else if (!this.validatorService.email(data['email'])) {
      error['email'] = this.errorService.email;
    }

    // validacion de TELEFONO
    if (this.validatorService.required(data['telefono']) && !this.validatorService.max(data['telefono'], 30)) {
      error['telefono'] = this.errorService.max(30);
    }

    // validacion de Dirección
    if (this.validatorService.required(data['direccion']) && !this.validatorService.max(data['direccion'], 200)) {
      error['direccion'] = this.errorService.max(200);
    }

    // validacion de CODIGO POSTAL
    if (this.validatorService.required(data['cp']) && !this.validatorService.max(data['cp'].toString(), 7)) {
      error['cp'] = this.errorService.max(7);
    }

    // validacion de COLONIA
    if (!this.validatorService.required(data['colonia'])) {
      error['colonia'] = this.errorService.required;
    } else if (!this.validatorService.max(data['colonia'], 50)) {
      error['colonia'] = this.errorService.max(50);
    }

    // validacion de NUMERO DE CUENTA
    if (!this.validatorService.required(data['numeroCuenta'])) {
      error['numeroCuenta'] = this.errorService.required;
    } else if (!this.validatorService.max(data['numeroCuenta'], 50)) {
      error['numeroCuenta'] = this.errorService.max(50);
    }

    // validacion de CLABE BANCO
    if (!this.validatorService.required(data['clabeBanco'])) {
      error['clabeBanco'] = this.errorService.required;
    } else if (!this.validatorService.max(data['clabeBanco'], 50)) {
      error['clabeBanco'] = this.errorService.max(50);
    }

    // validacion de BANCO
    if (!this.validatorService.required(data['nombreBanco'])) {
      error['nombreBanco'] = this.errorService.required;
    } else if (!this.validatorService.max(data['nombreBanco'], 70)) {
      error['nombreBanco'] = this.errorService.max(70);
    }

    return error;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/inversionistas.service.ts